import { render, staticRenderFns } from "./modal-spec.vue?vue&type=template&id=2f7f6376"
import script from "./modal-spec.vue?vue&type=script&lang=js"
export * from "./modal-spec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports